<template>
  <section id="mass-tariff-update">
    <ul class="nav nav-pills nav-justified mai-nav-pills">
      <li @click="pill = 'details'" :class="[ pill === 'details' ? 'active' : '' ]"><a>Details</a></li>
      <li @click="pill = 'accs'" :class="[ pill === 'accs' ? 'active' : '' ]"><a>Additions</a></li>
      <li @click="pill = 'locations'" :class="[ pill === 'locations' ? 'active' : '' ]"><a>Locations</a></li>
      <li @click="pill = 'vendors'" :class="[ pill === 'vendors' ? 'active' : '' ]"><a>Vendors</a></li>
    </ul>
    <div class="mass-udpate-content clearfix">
      <blockquote>Update {{ updateLabel }}</blockquote>
      <div class="col-xs-12 col-sm-6" v-if="ratesOrAccs">
        <div class="form-group">
          <label for="mass-update-type" class="form-label">Increase/Decrease</label>
          <select id="mass-update-type" class="form-control" v-model="request.direction">
            <option value=""></option>
            <option value="inc">Increase</option>
            <option value="dec">Decrease</option>
          </select>
        </div>
      </div>
      <div class="col-xs-12 col-sm-6" v-if="ratesOrAccs">
        <div class="form-group">
          <label for="mass-update-fp" class="form-label">Flat/Percentage</label>
          <select id="mass-update-fp" class="form-control" v-model="request.type">
            <option value=""></option>
            <option value="flat">Flat</option>
            <option value="percentage">Percentage</option>
          </select>
        </div>
      </div>
      <div class="col-xs-12 col-sm-6" v-if="pill === 'accs'">
        <div class="form-group">
          <label for="mass-update-sc" class="form-label">Financial Code</label>
          <select id="mass-update-sc" class="form-control" v-model="request.financialCode">
            <option value=""></option>
            <option v-for="opt in financialCodes" :value="opt.id">{{ opt.name }}</option>
          </select>
        </div>
      </div>
      <div class="col-xs-12 col-sm-6" v-if="ratesOrAccs">
        <div class="form-group">
          <label for="mass-update-amount" class="form-label">Amount</label>
          <input type="number" id="mass-update-amount" class="form-control" v-model="request.amount">
        </div>
      </div>
      <div v-if="pill === 'locations'">
        <div class="col-xs-12 col-sm-6">
          <div class="form-group">
            <label class="form-label">Origin Location</label>
            <autocomplete
              :dataset="locationSearchResults"
              title="Origin Location"
              placeHolder="Type to search"
              :initVal="locations.originLocation"
              v-on:changing="data => locationSearchText = data"
              :fnFormatText="locationFormat"
              :fnSelectValue="locationFormat"
              v-on:selection-made="updateFrom"
            >
            </autocomplete>
          </div>
        </div>
        <div class="col-xs-12 col-sm-6">
          <div class="form-group">
            <label class="form-label">Destination Location</label>
            <autocomplete
              :dataset="locationSearchResults"
              title="Destination Location"
              placeHolder="Type to search"
              :initVal="locations.destinationLocation"
              v-on:changing="data => locationSearchText = data"
              :fnFormatText="locationFormat"
              :fnSelectValue="locationFormat"
              v-on:selection-made="updateTo"
            >
            </autocomplete>
          </div>
        </div>
        <div class="col-xs-12 col-sm-6">
          <div class="form-group">
            <label class="form-label">On Carriage Location</label>
            <autocomplete
              :dataset="locationSearchResults"
              title="On Carriage Location"
              placeHolder="Type to search"
              :initVal="locations.onCarriageLocation"
              v-on:changing="data => locationSearchText = data"
              :fnFormatText="locationFormat"
              :fnSelectValue="locationFormat"
              v-on:selection-made="updateOnCarriage"
            >
            </autocomplete>
          </div>
        </div>
        <div class="col-xs-12 col-sm-6">
          <div class="form-group">
            <label class="form-label">Pre Carriage Location</label>
            <autocomplete
              :dataset="locationSearchResults"
              title="Pre Carriage Location"
              placeHolder="Type to search"
              :initVal="locations.preCarriageLocation"
              v-on:changing="data => locationSearchText = data"
              :fnFormatText="locationFormat"
              :fnSelectValue="locationFormat"
              v-on:selection-made="updatePreCarriage"
            >
            </autocomplete>
          </div>
        </div>
      </div>
      <div v-if="pill === 'vendors'">
        <div class="col-xs-12 col-sm-6">
          <div class="form-group">
            <label class="form-label">Owner</label>
            <autocomplete
              :dataset="partySearchResults"
              title="Owner"
              placeHolder="Type to search"
              :initVal="owner"
              v-on:changing="data => partySearchText = data"
              :fnFormatText="displayParty"
              :fnSelectValue="displayParty"
              v-on:selection-made="selectOwner"
            ></autocomplete>
          </div>
        </div>
      </div>
      <div class="col-xs-12">
        <div :class="[ !canUpdate ? 'disabled': '', 'btn btn-success sq full-fw' ]" @click="update">
          Update
        </div>
      </div>
      <div class="col-xs-12">
        <div class="alert alert-danger" v-if="exceededLimit" style="margin:10px;">
          <strong>Limit Exceeded!</strong> You have exceeded the tariff update limit of {{ maxLinesDefault }} (see System Option 'MAXIMUM_TARIFF_UPDATES')!
        </div>
        <h4 class="text-center mass-warn" v-if="pill === 'details'">
          --- This will affect {{ maxValue }} tariff(s) and {{ details }} line(s) ---
        </h4>
        <h4 class="text-center mass-warn" v-else-if="pill === 'vendors'">
          --- This will affect {{ maxValue }} tariff(s) ---
        </h4>
        <h4 class="text-center mass-warn" v-else>
          --- This will affect a maximum of {{ maxValue }} tariff(s) and a maximum of {{ additions }} accessorial(s) ---
        </h4>
      </div>
    </div>
  </section>
</template>
<script>
  import event from '../../../../event'
  import Helper from '../../mixins/Helpers'
  import API from '../../../../api/endpoints'
  import Autocomplete from '../../../helpers/AutoComplete.vue'
  export default {
    name: 'MassUpdate',
    components: { Autocomplete },
    mixins: [ Helper ],
    props: {
      tariffs: {
        type: Array,
        required: true
      },
      details: {
        type: Number,
        required: true,
        default: 0
      },
      maxValue: {
        type: Number,
        required: true,
        default: 0
      },
      additions: {
        type: Number,
        required: true,
        default: 0
      },
      req: {
        type: Object,
        required: true,
        default: () => {
          return {}
        }
      }
    },
    data () {
      return {
        pill: 'details',
        request: {
          financialCode: null,
          direction: '',
          amount: 0,
          type: ''
        },
        locations: {
          originLocation: null,
          destinationLocation: null,
          onCarriageLocation: null,
          preCarriageLocation: null
        },
        locationSearchResults: [],
        locationSearchText: '',
        owner: null
      }
    },
    computed: {
      locationRequestData () {
        const obj = {}
        for (let prop in this.locations) {
          if (this.locations[prop] && this.locations[prop].id) {
            obj[prop] = this.locations[prop].id
          }
        }
        return obj
      },
      vendorRequestData () {
        const obj = { ...this.req }
        obj.owner = this.owner
        return obj
      },
      ratesOrAccs () {
        return this.pill === 'details' || this.pill === 'accs'
      },
      updateLabel () {
        if (this.pill === 'details') {
          return 'Rates'
        } else if (this.pill === 'locations') {
          return 'Locations'
        } else if (this.pill === 'vendors') {
          return 'Vendors'
        }
        return 'Static Costs'
      },
      financialCodes () {
        return this.$store.getters['systemOption/financialCodes']
      },
      canUpdate () {
        return this.pill === 'details' ? this.criteriaIsFilled && !this.exceededLimit
          : this.pill === 'locations' ? !this.exceededLimit
            : this.pill === 'vendors' ? this.owner && !this.exceededLimit
            : (this.criteriaIsFilled && this.request.financialCode !== null && this.request.financialCode !== '') && !this.exceededLimit
      },
      criteriaIsFilled () {
        return this.request.direction !== '' && this.request.amount > 0 && this.request.type !== ''
      },
      maximums () {
        return this.getSystemOptions('MAXIMUM')
      },
      exceededLimit () {
        return this.maxValue > this.maxLinesDefault
      },
      maxLinesDefault () {
        let maxLines = this.maximums.find(({code}) => code === 'MAXIMUM_TARIFF_UPDATES')
        return maxLines ? maxLines.valueNumeric : 0
      },
      updateType () {
        return this.pill === 'details' ? 'lookup-detail' : this.pill === 'vendors' ? 'vendors' : 'lookup-addition'
      },
      requestParsed () {
        return {
          ...this.request,
          amount: parseFloat(this.request.amount)
        }
      },
      requestBody () {
        return {
          ...this.requestParsed,
          ...this.req
        }
      }
    },
    methods: {
      clearLocationData () {
        this.locationSearch = ''
        this.locationSearchResults = []
      },
      updateTo (to) {
        this.locations.destinationLocation = to
        this.clearLocationData()
      },
      updateFrom (from) {
        this.locations.originLocation = from
        this.clearLocationData()
      },
      updateOnCarriage (oCL) {
        this.locations.onCarriageLocation = oCL
        this.clearLocationData()
      },
      updatePreCarriage (pCL) {
        this.locations.preCarriageLocation = pCL
        this.clearLocationData()
      },
      locationFormat (location) {
        let str = ''
        if (location) {
          if (location.name) {
            str += location.name
          }
          if (location.subdivision) {
            str += `, ${location.subdivision}`
          }
          if (typeof location.country === 'object' && location.country !== null && location.country.hasOwnProperty('code')) {
            str += `, ${location.country.code}`
          }
        }
        return str
      },
      doMassUpdate (requestBody) {
        this.$http.put(API.MASS_UPDATE_TARIFF_RELATIONS(this.updateType), requestBody)
          .then(res => event.$emit('toast', {type: 'success', message: 'Updates complete'}))
          .catch(err => {
            console.log(err)
            event.$emit('toast', {type: 'error', message: 'Some details unable to update'})
          })
      },
      update () {
        if (this.canUpdate) {
          if (this.pill === 'vendors') {
            this.doMassUpdate(this.vendorRequestData)
          } else if (this.pill !== 'locations') {
            this.doMassUpdate(this.requestBody)
          } else {
            const messages = []
            if (!this.requestBody.lookup || (!this.requestBody.lookup.code && !this.requestBody.lookup.owner)) {
              messages.push('Code or owner on Mass Update Filter is mandatory')
            }
            if (this.locationRequestData.originLocation && (!this.requestBody.lookupDetail || !this.requestBody.lookupDetail.originLocation)) {
              messages.push('Origin Location on Mass Update Filter is mandatory')
            }
            if (this.locationRequestData.destinationLocation && (!this.requestBody.lookupDetail || !this.requestBody.lookupDetail.destinationLocation)) {
              messages.push('Destination Location on Mass Update Filter is mandatory')
            }
            if (this.locationRequestData.onCarriageLocation && (!this.requestBody.lookupDetail || !this.requestBody.lookupDetail.onCarriageLocation)) {
              messages.push('On Carriage Location on Mass Update Filter is mandatory')
            }
            if (this.locationRequestData.preCarriageLocation && (!this.requestBody.lookupDetail || !this.requestBody.lookupDetail.preCarriageLocation)) {
              messages.push('Pre Carriage Location on Mass Update Filter is mandatory')
            }
            if (messages.length) {
              messages.forEach(message => {
                event.$emit('toast', { type: 'warning', message })
              })
            } else {
              this.$http.put(API.MASS_UPDATE_TARIFF_RELATIONS('locations'), {
                ...this.requestBody,
                ...this.locationRequestData
              })
                .then(res => event.$emit('toast', {type: 'success', message: 'Updates complete'}))
                .catch(err => {
                  console.log(err)
                  event.$emit('toast', {type: 'error', message: 'Some details unable to update'})
                })
            }
          }
        } else {
          event.$emit('toast', { type: 'warning', message: 'Complete all fields before continuing and ensure your are not updating more than ' + this.maxLinesDefault + ' tariffs' })
        }
      },
      selectOwner (o) {
        this.owner = o
        this.partySearchText = ''
        this.partySearchResults = []
      }
    }
  }
</script>
<style>
  #mass-tariff-update {
    padding: 10px 10px 30px 10px;
    background-color: #eee;
    margin: 0 10px;
    -webkit-box-shadow: 0px 0px 10px 2px rgba(68,68,68,0.82);
    -moz-box-shadow: 0px 0px 10px 2px rgba(68,68,68,0.82);
    box-shadow: 0px 0px 10px 2px rgba(68,68,68,0.82);
    transition: all 0.5s;
  }
  #mass-tariff-update:hover {
    -webkit-box-shadow: 0px 0px 20px 5px rgba(68,68,68,0.82);
    -moz-box-shadow: 0px 0px 20px 5px rgba(68,68,68,0.82);
    box-shadow: 0px 0px 20px 5px rgba(68,68,68,0.82);
  }
  .mass-udpate-content {
    padding: 10px;
    background-color: #f7f7f7;
  }
  .mass-udpate-content blockquote {
    border-left: 5px solid #3c8dbc;
  }
  .mass-udpate-content .btn {
    display: inline-block;
    float: right;
  }
  @media(max-width:576px) {
    .mass-udpate-content .btn {
      display: block;
      width: 100%;
    }
  }
  .mass-warn {
    font-weight: bold;
  }
</style>



// WEBPACK FOOTER //
// src/modules/admin/components/Tariff/MassUpdate.vue